module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page albums-page mx-5",
    class: {
      isComp: _vm.isComp,
      onMobile: _vm.onMobile
    },
    attrs: {
      "id": "page-content"
    }
  }, [(!_vm.isComp && !_vm.onMobile) ? _c('discover-nav', {
    attrs: {
      "pageName": "music",
      "filterShow": "true",
      "searchShow": this.$store.state.app.sideBarMini
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPageReady) ? _c('div', {
    staticClass: "page-content"
  }, [(_vm.viewAllTrending) ? _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "pt-4": ""
    }
  }, [_c('div', [_c('content-top-header', {
    staticClass: "__inner mt-3",
    attrs: {
      "absolute": ""
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "width100 trending-topbar"
  }, [_c('li', [_c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "ripple": false,
      "fab": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-li"
  }, [_c('label', {
    class: (_vm.viewAllTrending) ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.displayTrendingTracks()
      }
    }
  }, [_vm._v("Trending")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-li"
  }, [_c('label', {
    on: {
      "click": function($event) {
        _vm.displayNewTracks()
      }
    }
  }, [_vm._v("New")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('li', [(false) ? _c('v-btn', {
    staticClass: "btn-genre-selector",
    attrs: {
      "dark": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        _vm.openGenreSelectorDialog()
      }
    }
  }, [_vm._v("\n                Genres: All\n                ")]) : _vm._e()], 1)], 1)])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "albums"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.recommendedAlbums), function(feed, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "feed-card": "",
        "xs6": "",
        "custom-lg6": "",
        "px-0": ""
      }
    }, [_c('track-card', {
      attrs: {
        "objects": _vm.recommendedAlbums,
        "objectIndex": index,
        "hideButtonAction": _vm.hideAlbum,
        "willMenuRender": ""
      }
    })], 1)
  }))], 1)]) : _vm._e(), _vm._v(" "), ((!_vm.viewAllPopular && !_vm.viewAllTrending)) ? _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "pt-4": "",
      "id": "new-album-container"
    }
  }, [(_vm.viewAllNew) ? _c('div', [_c('content-top-header', {
    staticClass: "__inner mt-3",
    attrs: {
      "absolute": ""
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "width100 trending-topbar"
  }, [_c('li', [_c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "ripple": false,
      "fab": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  })], 1), _vm._v(" "), _c('li', [_c('label', {
    on: {
      "click": function($event) {
        _vm.displayTrendingTracks()
      }
    }
  }, [_vm._v("Trending")])]), _vm._v(" "), _c('li', [_c('label', {
    class: (_vm.viewAllNew) ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.displayNewTracks()
      }
    }
  }, [_vm._v("New Release")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('li', [(false) ? _c('v-btn', {
    staticClass: "btn-genre-selector",
    attrs: {
      "dark": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        _vm.openGenreSelectorDialog()
      }
    }
  }, [_vm._v("\n                Genres: All\n                ")]) : _vm._e()], 1)], 1)])], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "albums"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.newAlbums), function(feed, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "feed-card": "",
        "sm3": "",
        "custom-lg6": "",
        "px-0": ""
      }
    }, [_c('track-card', {
      attrs: {
        "objects": _vm.newAlbums,
        "objectIndex": index,
        "hideButtonAction": _vm.hideAlbum,
        "willMenuRender": ""
      }
    })], 1)
  }))], 1)]) : _vm._e(), _vm._v(" "), ((!_vm.viewAllNew && !_vm.viewAllTrending)) ? _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "pt-4": "",
      "id": "popular-album-container"
    }
  }, [(_vm.viewAllPopular) ? _c('div', [_c('content-top-header', {
    staticClass: "__inner mt-3",
    attrs: {
      "absolute": ""
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "width100 trending-topbar"
  }, [_c('li', [_c('v-btn', {
    staticClass: "back-btn",
    attrs: {
      "ripple": false,
      "fab": "",
      "small": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  })], 1), _vm._v(" "), _c('li', [_c('label', {
    on: {
      "click": function($event) {
        _vm.displayTrendingTracks()
      }
    }
  }, [_vm._v("Trending")])]), _vm._v(" "), _c('li', [_c('label', {
    on: {
      "click": function($event) {
        _vm.displayNewTracks()
      }
    }
  }, [_vm._v("New")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('li', [(false) ? _c('v-btn', {
    staticClass: "btn-genre-selector",
    attrs: {
      "dark": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        _vm.openGenreSelectorDialog()
      }
    }
  }, [_vm._v("\n                Genres: All\n                ")]) : _vm._e()], 1)], 1)])], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "albums"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.popularAlbums), function(feed, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "feed-card": "",
        "sm3": "",
        "custom-lg6": "",
        "px-0": ""
      }
    }, [_c('track-card', {
      attrs: {
        "objects": _vm.popularAlbums,
        "objectIndex": index,
        "hideButtonAction": _vm.hideAlbum,
        "willMenuRender": ""
      }
    })], 1)
  }))], 1)]) : _vm._e()], 1) : _c('div', {
    staticClass: "page-loader"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/loader.gif"),
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.currentUser) ? _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.onMobile,
      "content-class": [("my-genre-dialog genre-filter ma-0 pa-2 " + (_vm.onMobile ? 'onMobile' : ''))]
    },
    model: {
      value: (_vm.show_genre_selector_dialog),
      callback: function($$v) {
        _vm.show_genre_selector_dialog = $$v
      },
      expression: "show_genre_selector_dialog"
    }
  }, [_c('genre-dialog', {
    attrs: {
      "dismiss": _vm.closeGenreSelectorDialog
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26526c57","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/album/index.vue
// module id = 1652
// module chunks = 180